/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import {
  Form, Input, Select, InputNumber,
  Checkbox,
  Popconfirm,
  Button,
} from 'antd';
import PropTypes, { func } from 'prop-types';
import { PlusOutlined } from '@ant-design/icons';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import { UsersSelect } from './UsersSelect';
import AddUserModal from './AddUserModal';
import { createUser } from '../../../../utils/http';


const { TextArea } = Input;
const { Option } = Select;

function parseJsonResponse(key, json) {
  if (!json || typeof json !== 'string') return null;

  const data = JSON.parse(json);
  return data?.[key];
}

const ProjectInfoPerson = ({
  item, index, formRef, application, onCreateCoexecutorProject,
}) => {
  const [isHaveThirdPerson, setIsHaveThirdPerson] = useState(parseJsonResponse('tz_third_person', item.meri_podderjki) || false);
  const [showUsersSearch, setShowUsersSearch] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedType, setSelectedType] = useState('nir');

  const updateIsHaveThirdPerson = (checked, rowIndex) => {
    const data = formRef.current.getFieldsValue();
    data.meri_podderjki[rowIndex].tz_not_third_person = !checked;
    formRef.current.setFieldsValue(data);
    setIsHaveThirdPerson(checked);
  };

  const handleCreateNewUser = async (values) => {
    const valuesWithID = {
      ...values,
      id: values.email,
    };

    const resp = await createUser(valuesWithID);

    if (resp.status === 'OK') {
      setSelectedUser(valuesWithID);
      setShowAddUserModal(false);
    }
  };

  const coexecutorsProject = application.coexecutors_id?.find((e) => e.coexecutorsPersonId === item.id);

  const steps = [
    item.isStep1,
    item.isStep2,
    item.isStep3,
    item.isStep4,
    item.isStep5,
    item.isStep6,
  ];

  const realisationIndex = (i) => {
    switch (i) {
      case 1:
      case 2:
        return 1;
      case 3:
      case 4:
        return 2;
      case 5:
      case 6:
        return 3;
      default:
        return null;
    }
  };


  useEffect(() => {
    const data = formRef.current.getFieldsValue();
    data.meri_podderjki[index].tz_third_person = isHaveThirdPerson;
    data.meri_podderjki[index].tz_not_third_person = !data.meri_podderjki[index].tz_third_person;
    formRef.current.setFieldsValue(data);
  }, [formRef]);


  return (
    <div key={item.fullName}>
      <Form.Item
        hidden
        name={['meri_podderjki', index, 'id']}
        initialValue={item.id}
      >
        <Input disabled />
      </Form.Item>
      <div className="common-sub-title" style={{ fontSize: '20px', marginBottom: '30px' }}>
        {item.fullName}
        <div style={{ marginTop: '10px' }}>
          {getUserRole() === 'bigAdmin' && (
          <>
            {!coexecutorsProject ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {!showUsersSearch && (
                  <Button type="primary" onClick={() => setShowUsersSearch(true)}>Создать проект соисполнителя</Button>
                )}

                {showUsersSearch && (
                  <>
                    {/* <UsersSelect selectedUser={selectedUser} onAddNewUser={() => setShowAddUserModal(true)} onUserSelect={setSelectedUser} /> */}
                    <Select
                      style={{
                        width: 600,
                        backgroundColor: '#fff',
                        marginLeft: '12px',
                      }}
                      placeholder="Тип"
                      value={selectedType}
                      onChange={(value) => setSelectedType(value)}
                      filterOption={false}
                    >
                      <Option value="nir">
                        НИР
                      </Option>
                      <Option value="s">
                        C
                      </Option>
                    </Select>
                    <Button type="danger" onClick={() => setShowUsersSearch(false)} style={{ marginLeft: '10px' }}>Отмена</Button>
                    <Popconfirm
                      title="Вы уверены, что хотите создать проект соисполнителя?"
                      onConfirm={() => onCreateCoexecutorProject(item.id, selectedType)}
                      okText="Да"
                      cancelText="Нет"
                    >
                      <Button style={{ marginLeft: 12 }} type="primary">Создать</Button>
                    </Popconfirm>
                  </>
                )}


                {showAddUserModal && (
                  <AddUserModal
                    onCloseModal={() => setShowAddUserModal(false)}
                    onSaveModal={handleCreateNewUser}
                  />
                )}
              </div>
            ) : (
              <Button target="_blank" href={`/application2/coexecutors/${coexecutorsProject.id}`} type="primary">Открыть проект соисполнителя</Button>
            )}
          </>
          )}
        </div>


      </div>

      <div
        className="common-sub-title"
        style={{ fontSize: '18px', marginBottom: '20px' }}
      >
        <b>Наименование работ, выполняемых в рамках этапа</b>
      </div>

      <div className="common-table-wrapper">
        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ width: '10%', textAlign: 'center', fontWeight: 'bold' }}
          >
            Номер этапа выполнения работ
          </div>
          <div
            className="common-table-row-cell"
            style={{ width: '10%', textAlign: 'center', fontWeight: 'bold' }}
          >
            Номер этапа реализации проекта
          </div>
          <div
            className="common-table-row-cell"
            style={{ width: '40%', textAlign: 'center', fontWeight: 'bold' }}
          >
            Наименование работ, выполняемых в рамках этапа
          </div>
          <div
            className="common-table-row-cell"
            style={{
              width: '19%',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1px solid #d9d9d9',
            }}
          >
            Объем финансирования, выполняемых в рамках этапа работ (в рублях)
          </div>
          <div
            className="common-table-row-cell"
            style={{
              width: '30%',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1px solid #d9d9d9',
            }}
          >
            Комментарий
          </div>
        </div>

        {steps.map((step, i) => (step ? (
          <div className="common-table-row">
            <Form.Item style={{ width: '10%' }} initialValue={i + 1}>
              <Input disabled value={i + 1} />
            </Form.Item>

            <Form.Item
              style={{ width: '10%' }}
              initialValue={realisationIndex(i + 1)}
            >
              <Input disabled value={realisationIndex(i + 1)} />
            </Form.Item>

            <Form.Item
              style={{ width: '40%' }}
              name={['meri_podderjki', index, `step${i + 1}Work`]}
              initialValue={parseJsonResponse(`step${i + 1}Work`, item.meri_podderjki) || item[`step${i + 1}Work`]}
            >
              <TextArea
                placeholder="Введите текст"
                autoSize
              />
            </Form.Item>

            <Form.Item
              style={{ width: '19%' }}
              initialValue={item[`step${i + 1}Sum`]}
            >
              <InputNumber
                formatter={(value) => (parseInt(value, 10) || 0).toLocaleString('ru-RU')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                disabled
                value={item[`step${i + 1}Sum`]}
              />
            </Form.Item>

            <Form.Item
              style={{ width: '30%' }}
              name={['meri_podderjki', index, `step${i + 1}Comment`]}
              initialValue={parseJsonResponse(`step${i + 1}Comment`, item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий"
                autoSize
              />
            </Form.Item>
          </div>
        ) : null))}

        <div className="common-table-row" style={{ borderBottom: '2px solid #d9d9d9' }}>
          <div
            className="common-table-row-cell"
            style={{
              fontWeight: 'bold', width: '75%', paddingRight: 15, borderRight: '1px solid #d9d9d9', textAlign: 'right',
            }}
          >
            Итого
          </div>
          <Form.Item
            initialValue={item.stepTotal}
            style={{ width: '28.5%' }}
          >
            <InputNumber
              formatter={(value) => (parseInt(value, 10) || 0).toLocaleString('ru-RU')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              disabled
              value={item.stepTotal}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </div>
      </div>

      <div
        className="common-sub-title"
        style={{ fontSize: '18px', marginBottom: '20px' }}
      >
        <b>
          Техническое задание на выполнение научно-исследовательских работ (НИР)
          и/или научно-исследовательских, опытно-конструкторских и
          технологических работ (НИОКР)
        </b>
      </div>
      <div className="common-table-wrapper">
        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ borderRight: '1px solid #d9d9d9' }}
          >
            Цель выполнения работ
          </div>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_target']}
            initialValue={parseJsonResponse('tz_target', item.meri_podderjki)}
          >
            <TextArea autoSize />
          </Form.Item>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_target_сomment']}
            initialValue={parseJsonResponse('tz_target_сomment', item.meri_podderjki)}
          >
            <TextArea
              style={{ color: 'red' }}
              disabled={getUserRole() !== 'bigAdmin'}
              placeholder="Комментарий администратора"
              autoSize
            />
          </Form.Item>
        </div>

        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ borderRight: '1px solid #d9d9d9' }}
          >
            Задачи, подлежащие решению в результате выполнения работ
          </div>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_tasks']}
            initialValue={parseJsonResponse('tz_tasks', item.meri_podderjki)}
          >
            <TextArea autoSize />
          </Form.Item>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_tasks_сomment']}
            initialValue={parseJsonResponse('tz_tasks_сomment', item.meri_podderjki)}
          >
            <TextArea
              style={{ color: 'red' }}
              disabled={getUserRole() !== 'bigAdmin'}
              placeholder="Комментарий администратора"
              autoSize
            />
          </Form.Item>
        </div>

        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ borderRight: '1px solid #d9d9d9' }}
          >
            Перечень результатов, подлежащих получению по факту завершения
            выполнения работ
          </div>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_results']}
            initialValue={parseJsonResponse('tz_results', item.meri_podderjki)}
          >
            <TextArea autoSize />
          </Form.Item>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_results_сomment']}
            initialValue={parseJsonResponse('tz_results_сomment', item.meri_podderjki)}
          >
            <TextArea
              style={{ color: 'red' }}
              disabled={getUserRole() !== 'bigAdmin'}
              placeholder="Комментарий администратора"
              autoSize
            />
          </Form.Item>
        </div>
        {/* <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ borderRight: '1px solid #d9d9d9' }}
          >
            Требования к выполняемым работам
          </div>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_work_requirements']}
            initialValue={parseJsonResponse('tz_work_requirements', item.meri_podderjki)}
          >
            <TextArea autoSize />
          </Form.Item>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_work_requirements_сomment']}
            initialValue={parseJsonResponse('tz_work_requirements_сomment', item.meri_podderjki)}
          >
            <TextArea
              style={{ color: 'red' }}
              disabled={getUserRole() !== 'bigAdmin'}
              placeholder="Комментарий администратора"
              autoSize
            />
          </Form.Item>
        </div> */}
        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ borderRight: '1px solid #d9d9d9' }}
          >
            Технические требования к научно-техническим результатам работ
          </div>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_technical_requirements']}
            initialValue={parseJsonResponse('tz_technical_requirements', item.meri_podderjki)}
          >
            <TextArea autoSize />
          </Form.Item>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_technical_requirements_сomment']}
            initialValue={parseJsonResponse('tz_technical_requirements_сomment', item.meri_podderjki)}
          >
            <TextArea
              style={{ color: 'red' }}
              disabled={getUserRole() !== 'bigAdmin'}
              placeholder="Комментарий администратора"
              autoSize
            />
          </Form.Item>
        </div>
        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ borderRight: '1px solid #d9d9d9' }}
          >
            Перечень разрабатываемой документации и требования к ее оформлению
          </div>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_documents_requirements']}
            initialValue={parseJsonResponse('tz_documents_requirements', item.meri_podderjki)}
          >
            <TextArea autoSize />
          </Form.Item>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_documents_requirements_сomment']}
            initialValue={parseJsonResponse('tz_documents_requirements_сomment', item.meri_podderjki)}
          >
            <TextArea
              style={{ color: 'red' }}
              disabled={getUserRole() !== 'bigAdmin'}
              placeholder="Комментарий администратора"
              autoSize
            />
          </Form.Item>
        </div>
        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ borderBottom: '1px solid #d9d9d9' }}
          >
            Этапы работ и сроки их выполнения
          </div>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_stages']}
            initialValue={parseJsonResponse('tz_stages', item.meri_podderjki)}
          >
            <TextArea autoSize />
          </Form.Item>
          <Form.Item
            style={{ width: '50%' }}
            name={['meri_podderjki', index, 'tz_stages_сomment']}
            initialValue={parseJsonResponse('tz_stages_сomment', item.meri_podderjki)}
          >
            <TextArea
              style={{ color: 'red' }}
              disabled={getUserRole() !== 'bigAdmin'}
              placeholder="Комментарий администратора"
              autoSize
            />
          </Form.Item>
        </div>
      </div>

      <Form.Item
        style={{ width: '50%' }}
        name={['meri_podderjki', index, 'tz_third_person']}
        initialValue={parseJsonResponse('tz_third_person', item.meri_podderjki)}
        valuePropName="checked"
      >
        <Checkbox
          defaultChecked={parseJsonResponse('tz_third_person', item.meri_podderjki)}
          value={parseJsonResponse('tz_third_person', item.meri_podderjki)}
          onChange={(e) => updateIsHaveThirdPerson(e.target.checked, index)}
        >
          Соисполнитель привлекает третье лицо для выполнения работ
        </Checkbox>
      </Form.Item>

      <Form.Item
        hidden
        name={['meri_podderjki', index, 'tz_not_third_person']}
        initialValue={parseJsonResponse('tz_not_third_person', item.meri_podderjki)}
        valuePropName="checked"
      >
        <Checkbox
          defaultChecked={parseJsonResponse('tz_not_third_person', item.meri_podderjki)}
          value={parseJsonResponse('tz_not_third_person', item.meri_podderjki)}
          checked={parseJsonResponse('tz_not_third_person', item.meri_podderjki)}
        >
          Соисполнитель не привлекает третье лицо для выполнения работ
        </Checkbox>
      </Form.Item>

      {isHaveThirdPerson && (
        <div className="common-table-wrapper">
          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Организационно-правовая форма и полное наименование организации
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_orgName']}
              initialValue={parseJsonResponse('tz_third_person_orgName', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_orgName_сomment']}
              initialValue={parseJsonResponse('tz_third_person_orgName_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Организационно-правовая форма и сокращенное наименование организации
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_shortName']}
              initialValue={parseJsonResponse('tz_third_person_shortName', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_shortName_сomment']}
              initialValue={parseJsonResponse('tz_third_person_shortName_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              ОГРН
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_ogrn']}
              initialValue={parseJsonResponse('tz_third_person_ogrn', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_ogrn_сomment']}
              initialValue={parseJsonResponse('tz_third_person_ogrn_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              ИНН
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_inn']}
              initialValue={parseJsonResponse('tz_third_person_inn', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_inn_сomment']}
              initialValue={parseJsonResponse('tz_third_person_inn_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              КПП
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_kpp']}
              initialValue={parseJsonResponse('tz_third_person_kpp', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_kpp_сomment']}
              initialValue={parseJsonResponse('tz_third_person_kpp_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Юридический адрес
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_address_legal']}
              initialValue={parseJsonResponse('tz_third_person_address_legal', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_address_legal_сomment']}
              initialValue={parseJsonResponse('tz_third_person_address_legal_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Почтовый адрес
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_address_post']}
              initialValue={parseJsonResponse('tz_third_person_address_post', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_address_post_сomment']}
              initialValue={parseJsonResponse('tz_third_person_address_post_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Адрес местонахождения
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_address_location']}
              initialValue={parseJsonResponse('tz_third_person_address_location', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_address_location_сomment']}
              initialValue={parseJsonResponse('tz_third_person_address_location_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Наименование выполняемых работ
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_work_name']}
              initialValue={parseJsonResponse('tz_third_person_work_name', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_work_name_сomment']}
              initialValue={parseJsonResponse('tz_third_person_work_name_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Стоимость выполняемых работ
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_work_price']}
              initialValue={parseJsonResponse('tz_third_person_work_price', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_work_price_сomment']}
              initialValue={parseJsonResponse('tz_third_person_work_price_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Сроки выполнения работ
            </div>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_work_term']}
              initialValue={parseJsonResponse('tz_third_person_work_term', item.meri_podderjki)}
            >
              <TextArea autoSize />
            </Form.Item>
            <Form.Item
              style={{ width: '50%' }}
              name={['meri_podderjki', index, 'tz_third_person_work_term_сomment']}
              initialValue={parseJsonResponse('tz_third_person_work_term_сomment', item.meri_podderjki)}
            >
              <TextArea
                style={{ color: 'red' }}
                disabled={getUserRole() !== 'bigAdmin'}
                placeholder="Комментарий администратора"
                autoSize
              />
            </Form.Item>
          </div>


        </div>
      )}
    </div>
  );
};

export default ProjectInfoPerson;

ProjectInfoPerson.propTypes = {
  item: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  formRef: PropTypes.shape().isRequired,
  application: PropTypes.shape().isRequired,
  onCreateCoexecutorProject: PropTypes.func.isRequired,
  // updateOriginalObject: PropTypes.func.isRequired,
};

